module.exports = __webpack_public_path__ + "img/alat-berat.1045fb72.webp";